import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

export const GenericPageBody = (
    props: Immutable<Pick<templates.GenericPageTemplate, "page">>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    // The legacy `{% include_block self.body %}` wrapped each top-level body
    // block in `<div class="block-{type}">` (Wagtail's StreamBlock rendering).
    // The generic-page block SCSS targets those wrappers globally -- e.g.
    // `.block-feature` / `.block-mega_hero` set the block layout and
    // `main > div.block-hero` zeroes its top margin. A bare
    // `<StreamField tagName={Fragment}>` emits the block components WITHOUT
    // those wrappers, dropping that layout. Reproduce one wrapper per top-level
    // block (same pattern as `HomePageBody`).
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{ className: `block-${block.type}` }}
                    value={[block]}
                    components={toolboxComponentsMap}
                />
            ))}
        </>
    );
};
